module.exports = __webpack_public_path__ + "static/media/logout.f449bf46.svg";